export const normalizeString = (str: string | null | undefined): string => {
  if (str === null || str === undefined || str === '') {
    return ''
  }
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}
